<template>
  <vx-card :title="t('nav_invoices')">
    <div v-if="loading" class="cp-state">
      <feather-icon icon="LoaderIcon" svgClasses="h-6 w-6" class="cp-spin" />
      <div>{{ t('loading') }}</div>
    </div>
    <div v-else-if="loadError" class="cp-state">
      <vs-alert color="danger" active="true">{{ loadError }}</vs-alert>
      <vs-button size="small" class="mt-4" @click="load">{{ t('retry') }}</vs-button>
    </div>
    <div v-else-if="!invoices.length" class="cp-state">
      <feather-icon icon="InboxIcon" svgClasses="h-8 w-8" />
      <div>{{ t('no_invoices') }}</div>
    </div>

    <vs-table v-else :data="invoices" search pagination :max-items="20" @selected="row => open('client-invoice', row.id)">
      <template slot="thead">
        <vs-th sort-key="invoice_no">{{ t('invoice_no') }}</vs-th>
        <vs-th sort-key="date">{{ t('date') }}</vs-th>
        <vs-th sort-key="kind">{{ t('type') }}</vs-th>
        <vs-th sort-key="idorder">{{ t('order') }}</vs-th>
        <vs-th v-if="manyCompanies" sort-key="company">{{ t('company') }}</vs-th>
        <vs-th>{{ t('total_excl') }}</vs-th>
        <vs-th>{{ t('amount_incl') }}</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr v-for="inv in data" :key="inv.id" :data="inv" class="cp-row-link">
          <vs-td :data="inv.invoice_no"><span class="font-semibold">{{ inv.invoice_no }}</span></vs-td>
          <vs-td :data="inv.date">{{ date(inv.date) }}</vs-td>
          <vs-td :data="inv.kind">
            <vs-chip :color="inv.kind === 'credit_note' ? 'danger' : inv.kind === 'advance' ? 'warning' : 'success'">{{ t('kind_' + inv.kind) }}</vs-chip>
          </vs-td>
          <vs-td :data="inv.idorder">{{ inv.idorder ? `#${inv.idorder}` : '—' }}</vs-td>
          <vs-td v-if="manyCompanies" :data="inv.company">{{ inv.company }}</vs-td>
          <vs-td class="cp-num">{{ amount(inv.totals.ht, inv.totals.currency) }}</vs-td>
          <vs-td class="cp-num">{{ amount(inv.totals.ttc, inv.totals.currency) }}</vs-td>
          <vs-td>
            <!-- Comme la colonne Actions des listes de l'ERP (CellRendererActions) : œil = fiche, fichier = PDF. -->
            <div class="flex items-center">
              <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" :title="t('details')" @click.stop="open('client-invoice', inv.id)" />
              <feather-icon v-if="inv.has_pdf" icon="FileTextIcon" title="PDF" :class="{ 'opacity-50 pointer-events-none': opening['invoice-' + inv.id] }"
                svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click.stop="viewPdf('invoice', inv.id)" />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
// Portail client → factures numérotées (factures, avoirs, acomptes), toutes ;
// clic → fiche (ClientDocument.vue), bouton PDF → PDF archivé dans un onglet.
import portalPage from '@/views/client/portalPage.js'

export default {
  name: 'ClientInvoices',
  mixins: [portalPage],
  data () {
    return { invoices: [] }
  },
  methods: {
    load () {
      return this.fetch('/invoices', (data) => { this.invoices = data.invoices || [] })
    }
  },
  created () {
    this.load()
  }
}
</script>
